import type { TPAComponentProps } from '../../types';

export interface DialogProps extends TPAComponentProps {
  /** Whether the modal is opened */
  isOpen?: boolean;
  /** Whether to use our focus trap or to manage the focus manually. */
  manualFocus?: boolean;
  /** Adds a ref for the close button. This prop might be used when you choose the manual focus. */
  closeButtonRef?: React.RefObject<HTMLButtonElement>;
  /** Callback for when the close button is clicked */
  onClose?(): void;
  /** Children to render inside dialog */
  children?: React.ReactNode;
  /** A class name that will be added to the content wrapper */
  contentClassName?: string;
  /** A class name that will be added to the dialog content */
  childrenWrapperClassName?: string;
  /** Defines a string value that labels the dialog element. Optional. */
  'aria-label'?: string;
  /** Identifies the element that labels the dialog element. Optional. */
  'aria-labelledby'?: string;
  /** Gives the dialog an accessible description by referring to the dialog content that describes the primary message or purpose of the dialog. Optional. */
  'aria-describedby'?: string;
  /** Defines a string value that labels the close button element. Optional. */
  closeButtonAriaLabel?: string;
  /** Identifies the element that labels the close button element. Optional. */
  closeButtonAriaLabelledby?: string;
  /** Whether the Dialog is wired to the site palette, or has a white background */
  wiredToSiteColors?: boolean;
  /** Determines whether Dialog should open in a non-fullscreen mode on mobile */
  notFullscreenOnMobile?: boolean;
  /** In case the variable set to true, Dialog should be rendered under the document.body DOM node */
  appendToBody?: boolean;
  /** In case the variable is set to true, Dialog will be rendered in black and white colors */
  forceBWTheme?: boolean;
}

export interface DialogDefaultProps {
  isOpen: boolean;
  manualFocus: boolean;
  notFullscreenOnMobile: boolean;
}
